
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getCpvCurp } from "../../api/getCpvCurp";
import { validateCurp } from "../../api/validateCurp";
import { mtfindIdPersonByIdenti } from "../../api/mtfindIdPersonByIdenti";
import Modal from "react-bootstrap/Modal";
import checkDefault from "../../assets/ok_default.svg";
import checkDone from "../../assets/ok_done.svg";
import foodbrand from "../../assets/foodbrand@2x.png";
import Pantalla2 from "../Pantalla2/Pantalla2";
import Header from "../../Header/Header";
import "./style.css";

function MyVerticallyCenteredModal(props) {

  const [onehabilita, setOnehabilita] = useState(true);

  return (

    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <span className="txtHead_P1">Uso de Cookies</span>
        </Modal.Title>
        <a
          href="https://mydpr.icu/"
          className="btn-close"
          role="button"
        ></a>
      </Modal.Header>
      <Modal.Body>
        <p className="txtMsj_P1">
          Sistema de Confiabilidad DPR SAPI, requiere el consentimiento del Uso
          de Cookies de todos los Usuarios de esta Aplicación Web. Las cookies
          son pequeños fragmentos de texto que nuestra Aplicación Web envía al
          navegador, permiten que las operaciones realizadas por Usuario
          recuerden información sobre la sesión, lo que facilita realizar
          verificaciones con fuentes externas y hacer que la secuencia de las
          Operaciones Realizadas sea más ágil.Otras tecnologías, como los
          identificadores únicos y geolocalización que se usan en el navegador,
          aplicación o dispositivo, los píxeles y el almacenamiento local,
          también se pueden usar para estos fines.
        </p>
        <div>
          <button
            className="buttonCookies_P1"
            onClick={() => setOnehabilita(!onehabilita)}
          >
            {<img align="left" src={!onehabilita ? checkDone : checkDefault} />}
            <div className="txtCookies_P1">Aceptar Uso de Cookies</div>
          </button>
        </div>
        <div className="spaceButtonModal" />
        <button
          className={!onehabilita ? "buttonModal_P1" : "buttonModal_disable"}
          onClick={props.onHide}
          disabled={onehabilita}
        >
          <div
            className={
              !onehabilita ? "txtButtonModal_P1" : "txtButtonModal_disable"
            }
          >
            Confirmar
          </div>
        </button>
      </Modal.Body>
      <div className="foorterBackground_P1">
        <Modal.Footer>
          <span className="txtFooorter_P1">
            IMPORTANTE: Consulte nuestro{" "}
            <span className="txtCookiesFooorter_P1">
              <a href="https://midpr.icu/cookies.php" target="_blank">
                Uso de Cookies
              </a>
            </span>{" "}
            para más detalles sobre la recolección y uso de datos.
          </span>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

function PantallaBase() {

  const isRunned = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [validateCurpCpv, setValidateCurpCpv] = useState(true);

  const onValidateFaceMach = async () => {
    navigate("/FaceLoginPassaporte", {
      state: {
        rutaContinue: "/PantallaBase27",
        typeCredential: "lic",
      },
    });
  };

  const onTest = async () => {
    navigate("/PantallaBase14");
  };

  useEffect(() => {

    if (isRunned.current) return;
    isRunned.current = true;

    async function createSession() {

      localStorage.clear();

      if (params.get("i") == null) {

        setLoading(false);
        setModalShow(false);
        setShow(true);
        setShowStatus(500);
        setShowMessage("Error al obtener el cpv");

      } else {

        setLoading(false);

        const obj = {
          sCpv: params.get("i")
        };

        const response = await getCpvCurp(obj);

        if (response.status === 200) {

          localStorage.setItem("sCpv", params.get("i"));
          localStorage.setItem("vigenciaCpv", response.vigencia);
          localStorage.setItem("telefono", response.telefono);

          const objValida = {
            curp: response.curp,
          };

          const responseValidate = await validateCurp(objValida);

          if (responseValidate.status === 200) {

            localStorage.setItem("nombre", responseValidate.nombre);
            localStorage.setItem("paterno", responseValidate.paterno);
            localStorage.setItem("materno", responseValidate.materno);

            const objPerson = {
              identificationNumberId: response.curp
            };

            const responseIdPerson = await mtfindIdPersonByIdenti(objPerson);

            if (responseIdPerson.status === 200) {
              localStorage.setItem("curpValidate", "" + response.curp);
              setValidateCurpCpv(true);
            }

            if (responseIdPerson.status === 400) {

              if (responseIdPerson.id != null && responseIdPerson.id !== '') {
                localStorage.setItem("idPerson", "" + responseIdPerson.id);
                localStorage.setItem("uuid", "" + responseIdPerson.uuid);
                setValidateCurpCpv(false);
              }

            }

            setModalShow(true);
            setLoading(true);

          } else {
            setLoading(true);
            setShow(true);
            setModalShow(false);
            setShowStatus(responseValidate.status);
            setShowMessage(responseValidate.message);
          }

        } else {

          setLoading(true);
          setShow(true);
          setModalShow(false);
          setShowStatus(500);
          setShowMessage("Error al obtener el cpv");

        }
      }
    }

    createSession();

  }, []);

  const handleClose = async () => {
    setShow(false);
    window.location.href = 'https://mydpr.icu/'
  };

  const onContinueModel = async () => {
    setModalShow(false);
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">

        <Header
          imgBack={false}
          rutaBack="/PantallaBase"
          title="Identificación Personal"
          image
          style={StyleSheet.absoluteFill}
          source={{
            uri: "https://upload.wikimedia.org/wikipedia/commons/3/36/Hopetoun_falls.jpg",
          }}
          name="steepOne"
        />


        {loading ? (
          <>
            <div className="containerRender">
              <Pantalla2 />
            </div>
            <div className="footer">
              <div className="containerCont_P2">

                {validateCurpCpv ? (
                  <>
                    <button className="button_P2" onClick={onTest}>
                      <span className="txtButton_P2">Confirmar</span>
                    </button>
                  </>
                ) : (
                  <>
                    <button className="button_P2" onClick={onValidateFaceMach}>
                      <span className="txtButton_P2">Confirmar</span>
                    </button>
                  </>
                )}

              </div>
              <div className="imageContainer_P2">
                <img src={foodbrand} className="imgFooter_P2" />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="containerRender">
              <div className="spinner"></div>
            </div>
          </>
        )}

      </div>

      <MyVerticallyCenteredModal show={modalShow} onHide={onContinueModel} />

      <Modal show={show} onHide={handleClose} animation={false} centered backdrop="static">
        <Modal.Body className="backGroudModal">
          <div className="msjTitleModalDiv">Error {showStatus}</div>
          <div className="msjErrorModal">{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className="button_P2" onClick={handleClose}>
            <span className="txtButton_P2">Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default PantallaBase;
